import React from "react"
import MegaMenu from "../MegaMenu"
import { countDaysFromDate } from "../../../../../../../utils/formatDate"

const MegaMenuJobAds = ({
  name = "",
  card = [],
  megaMenuData = [],
  isMegaMenuActive,
  triggerParentUpdate,
}) => {
  const data = megaMenuData.map((item) => {
    const { autoRoute, title, agence, creationDate } = item.attributes
    return {
      route: autoRoute,
      label: title,
      subTitle: `${agence?.data?.attributes.name}, il y a ${countDaysFromDate(
        creationDate
      )}`,
    }
  })
  return (
    <MegaMenu
      data={data}
      name={name}
      card={card && card}
      isMegaMenuActive={isMegaMenuActive}
      triggerParentUpdate={triggerParentUpdate}
    />
  )
}

export default MegaMenuJobAds
